module.exports = __webpack_public_path__ + "img/contracts.2ff5cf58.svg";